const alpha = (color, alpha = 1) => {
  const type = color.slice(0, 3);
  return color.replace(type, `${type}a`).replace(')', `, ${alpha})`);
}

export default alpha;



// WEBPACK FOOTER //
// ./src/styles/alpha.js